"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const mutation_types_1 = require("./mutation-types");
exports.default = {
    startLoading({ commit }) {
        commit(mutation_types_1.MutationTypes.SET_LOADING, true);
    },
    stopLoading({ commit }) {
        commit(mutation_types_1.MutationTypes.SET_LOADING, false);
    },
};
//# sourceMappingURL=actions.js.map